import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core/styles';
import defaults from '../../translations/en.json';

const OverlayRoot = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  pointer-events: none;
`;

export const CalendarLoadingOverlay = () => {
  const {
    props: { grid: gridTheme },
  } = useTheme() as any;

  return (
    <OverlayRoot
      className={`${gridTheme.className} light max-width`}
      data-sv-loading="true"
    >
      <div className="ag-overlay" aria-hidden="true">
        <div className="ag-overlay-panel" role="presentation">
          <div className="ag-overlay-wrapper ag-layout-normal ag-overlay-loading-wrapper">
            <span className="ag-overlay-loading-center">
              {defaults.loading}
            </span>
          </div>
        </div>
      </div>
    </OverlayRoot>
  );
};
